/** Explicit troubleshooting overrides; never guess the transport from device type. */
export function getVoiceTransport(mode: 'chat' | 'voice', search: string) {
    const preference = new URLSearchParams(search).get('voiceTransport')
    if (mode === 'chat' || preference === 'websocket') {
        return { connectionType: 'websocket' as const, relay: false }
    }
    return { connectionType: 'webrtc' as const, relay: preference === 'relay' }
}
